'use client';

import { Fragment, PropsWithChildren, ReactNode, useRef } from 'react';
import { SubmitButton } from '@pioz/mlm-skeleton/form-fields';

export interface DialogWithSubmitT {
  back: string;
  confirm: string;
}

export function DialogWithSubmit({
  openButtonClass,
  openButtonContent,
  action,
  submitData,
  dialogHeader,
  children,
  t,
}: PropsWithChildren<{
  openButtonClass?: string;
  openButtonContent: ReactNode;
  action: (data: FormData) => Promise<void>;
  submitData: { name: string; value: string | number }[];
  dialogHeader: string;
  t: DialogWithSubmitT;
}>) {
  const ref = useRef<HTMLDialogElement>(null);

  return (
    <Fragment>
      <button className={openButtonClass} onClick={() => ref.current?.showModal()}>
        {openButtonContent}
      </button>
      <dialog ref={ref} className="modal">
        <div className="modal-box">
          <h1 className="text-xl font-bold">{dialogHeader}</h1>
          {children}
          <div className="modal-action">
            <form method="dialog">
              <button className="btn btn-success">{t.back}</button>
            </form>
            <form
              action={async (data) => {
                await action(data);
                ref.current?.close();
              }}
            >
              {submitData.map((item) => (
                <input key={item.name} type="hidden" name={item.name} value={item.value} />
              ))}
              <SubmitButton className="btn btn-warning">{t.confirm}</SubmitButton>
            </form>
          </div>
        </div>
      </dialog>
    </Fragment>
  );
}
